import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {Title, Meta} from "@angular/platform-browser";
import { Router } from '@angular/router';
import { DownloadAppComponent } from 'src/app/components/download-app/download-app.component';

import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, PromoBannerStrip } from 'src/environments/environment.interface';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
    bannerObj!: PromoBannerStrip;
    @ViewChild('download') downloadPopup!: DownloadAppComponent;
    hideTimeout: number = 0;
    settings: FacilityConfig;
    orderedComponents: any[] = [];
    constructor(
        private titleService: Title,
        private meta: Meta,
        private alertService: AlertService,
        private auth: AuthService,
        private router: Router,
        private _environmentService: EnvironmentService
    ) { 
        this.settings = this._environmentService.getFacilityConfig();
        this.titleService.setTitle(this.settings.meta.title);
        this.meta.updateTag({ name: "description", content: this.settings.meta.description });

        this.meta.updateTag({ name: "canonical", content: this.settings.meta.canonicalUrl });

        this.meta.updateTag({ name: "og:locale", content: this.settings.meta.ogLocale });
        this.meta.updateTag({ name: "og:type", content: this.settings.meta.ogType });
        this.meta.updateTag({ name: "og:title", content: this.settings.meta.ogTitle });
        this.meta.updateTag({ name: "og:description", content: this.settings.meta.ogDescription });
        this.meta.updateTag({ name: "og:url", content: this.settings.meta.ogUrl });
        this.meta.updateTag({ name: "og:site_name", content: this.settings.meta.ogSiteName });
        this.meta.updateTag({ name: "og:image", content: this.settings.meta.ogImage });
        this.meta.updateTag({ name: "twitter:card", content: this.settings.meta.twitterCard });
        this.meta.updateTag({ name: "twitter:url", content: this.settings.meta.twitterUrl });
        this.meta.updateTag({ name: "twitter:domain", content: this.settings.meta.twitterDomain });
        this.meta.updateTag({ name: "twitter:title", content: this.settings.meta.twitterTitle });
        this.meta.updateTag({ name: "twitter:description", content: this.settings.meta.twitterDescription });
        this.meta.updateTag({ name: "twitter:image", content: this.settings.meta.twitterImage });

        if (this.settings.facebookDomainVerification) {
            this.meta.updateTag({ name: "facebook-domain-verification", content: this.settings.facebookDomainVerification });
        }

        this.bannerObj = this._environmentService.getPromoBanner('homePage');
      }

    ngOnInit(): void {
        if (this._environmentService.getProperty('routes')?.home) {
            this.router.navigate([this._environmentService.getProperty('routes')?.home]);
        }
        this.alertService.readPersistentAlerts();
        this.initializeOrderedComponents();
    }

    initializeOrderedComponents(): void {
        const homePage = this.settings.homePage;
        const components = [
            { key: 'banner', component: 'app-banner', show: homePage.banner?.show },
            { key: 'pricing', component: 'app-pricing', show: homePage.pricing?.show },
            { key: 'classes', component: 'app-classes', show: homePage.classes?.show },
            { key: 'instructors', component: 'app-instructors', show: homePage.instructors?.show },
            { key: 'training', component: 'app-training', show: homePage.training?.show },
            { key: 'wellness', component: 'app-wellness', show: homePage.wellness?.show },
            { key: 'videoWidget', component: 'app-video-widget', show: homePage.videoWidget?.show }
        ];

        // Filter components that should be shown and sort by order
        this.orderedComponents = components
            .filter(comp => comp.show)
            .map(comp => ({
                ...comp,
                order: (homePage[comp.key as keyof typeof homePage] as any)?.order || 999
            }))
            .sort((a, b) => a.order - b.order);
    }

    ngAfterViewInit(): void {
        if (!this.auth.isLoggedIn() && this.settings.signupPopup.slides && this.settings.signupPopup.slides.length > 0) {
            window.setTimeout(() => this.downloadPopup.open());
            this.hideTimeout = window.setTimeout(() => this.downloadPopup.dismiss(), 10000);
        }
    }

    dlPopupClicked() {
        if (this.hideTimeout) {
            window.clearTimeout(this.hideTimeout);
            this.hideTimeout = 0;
        }
    }

    isLoggedIn(): boolean {
        return this.auth.isLoggedIn();
    }

}